import { create } from 'zustand';
import { type AuthInfo } from '@avanta/shared/types/auth';

export interface AuthState {
  authInfo: AuthInfo | null;
  token: () => string | null;
  setAuthInfo: (info: AuthInfo) => void;
  clearAuth: () => void;
}

export const useAuthStore = create<AuthState>((set, get) => ({
  authInfo: null,
  token: (): string | null => get().authInfo?.access_token ?? null,
  setAuthInfo: (info): void => set({ authInfo: info }),
  clearAuth: (): void => set({ authInfo: null }),
}));
